// LA CHASSE (26/07, chantier 1 des trois proposés, choisi par Claude-Alain).
//
// Constat mesuré en base de production avant d'écrire une ligne : sur les sept premiers niveaux du
// parcours, la moyenne de morts par joueur va de 0,0 à 0,9. On traverse le jeu sans mourir. Or le
// plaisir d'un Lode Runner, c'est la fuite de justesse — et on ne peut pas fuir ce qui ne poursuit
// pas.
//
// Deuxième constat, en lisant le catalogue : la meute EXISTE déjà (anticipation deux cases devant,
// ligne de vue, mémoire de la dernière position, patrouille, et les bulles ! / ? / z au-dessus des
// capuches), et le drapeau `smartMonks` qui l'allume était FAUX sur dix niveaux sur onze. Le
// chantier n'était donc pas d'écrire une IA : c'était de la brancher, et de lui donner ce qui lui
// manquait vraiment — du SON quand elle te repère, et une récompense quand tu lui échappes.
//
// Module PUR (ni DOM, ni canvas, ni simulation) : rien ici n'entre dans le hash d'état.

/** Distance de « frôlement », en sous-unités (SUB = 8 par case). Un moine à moins d'une case. */
export const FROLEMENT_SUB = 10
/** Au-delà, on considère le danger passé et une nouvelle approche pourra compter. */
export const SORTIE_SUB = 20

export interface Chasse {
  /** Nombre de fois où on s'est extrait d'un frôlement sans mourir, sur le niveau en cours. */
  esquives: number
  /** Vrai tant qu'on est ENCORE dans le rayon du frôlement en cours (une approche = une esquive). */
  dedans: boolean
}

export const CHASSE_VIDE: Chasse = { esquives: 0, dedans: false }

/**
 * Fait avancer le compte d'esquives d'un tick, à partir de la distance de Chebyshev au moine le
 * plus proche (en sous-unités ; `Infinity` s'il n'y a pas de moine).
 *
 * ⚠️ Une esquive se compte à la SORTIE du rayon, pas à l'entrée : sinon on récompenserait le fait
 * de s'être mis en danger, et un joueur collé à un moine ferait grimper le compteur sans rien
 * réussir. Et il faut vraiment RESSORTIR (SORTIE_SUB > FROLEMENT_SUB) : sans cette marge, osciller
 * d'une sous-unité autour de la limite compterait dix esquives par seconde.
 */
export function chasseSuivante(c: Chasse, distSub: number, vivant: boolean): Chasse {
  if (!vivant) return { esquives: c.esquives, dedans: false } // mort : l'approche en cours n'est pas une esquive
  if (!c.dedans) return distSub <= FROLEMENT_SUB ? { esquives: c.esquives, dedans: true } : c
  if (distSub >= SORTIE_SUB) return { esquives: c.esquives + 1, dedans: false }
  return c
}

/**
 * Vrai quand un moine vient de te REPÉRER : il passe à 'alert' alors qu'il ne l'était pas.
 * C'est ce front montant, et lui seul, qui mérite un son — sinon un moine qui te voit en continu
 * hurlerait trente fois par seconde.
 */
export function vientDeReperer(avant: string | null, apres: string | null): boolean {
  return apres === 'alert' && avant !== 'alert'
}
